import { useDecisionEngineFlowQuery } from "src/graphql";
import {
  MeasurementScope,
  type MeasuringSelection,
} from "src/pages/analytics/types";

/**
 * Hook for fetching the current measuring selection's metric resources to do
 * any specific processing or formatting needed for the measuring selection
 * The return object is meant to be flexible so each asset can do what it needs
 */
export const useMeasuringMetricResources = ({
  measuringSelection,
}: {
  measuringSelection: MeasuringSelection | undefined;
}): Record<string, unknown> => {
  const { data: flow } = useDecisionEngineFlowQuery(
    {
      id: measuringSelection?.id?.toString() ?? "",
    },
    {
      enabled:
        measuringSelection?.scope === MeasurementScope.DecisionEngineFlow,
      select: (data) => data.decision_engine_flows_by_pk,
    },
  );

  switch (measuringSelection?.scope) {
    case MeasurementScope.DecisionEngineFlow: {
      const outcomes = flow?.outcomes.map((o) => o.outcome) ?? [];
      const flowMessages = flow?.messages ?? [];
      const flowConfig = flow?.config;
      return {
        flowConfig,
        outcomes,
        flowMessages,
      };
    }
    case MeasurementScope.AllData:
    default:
      return {};
  }
};
